export interface LegacyAmlogicDevice {
  chip: string;
  family: string;
  protocol: string;
  usbIdentity: string;
  imageFormat: string;
  support: string;
}

/** Known legacy USB boot PID. Other stages may enumerate with a different PID. */
export const LEGACY_AMLOGIC_PRODUCT_IDS = [0xc003] as const;

/**
 * Devices commonly handled by the pre-ADNL Amlogic USB Burning Tool v2.
 * This catalog is intentionally separate from the S4/S905W2 ADNL flow.
 */
export const LEGACY_AMLOGIC_DEVICES: readonly LegacyAmlogicDevice[] = [
  {
    chip: "S905X",
    family: "GX / GXL",
    protocol: "USB Burning Tool v2 · legacy",
    usbIdentity: "VID 0x1B8E · PID 0xC003 thường gặp",
    imageFormat: "aml_upgrade_package.img",
    support: "Flash Legacy v2 thử nghiệm",
  },
  {
    chip: "S905X2",
    family: "G12A",
    protocol: "USB Burning Tool v2 · legacy",
    usbIdentity: "VID 0x1B8E · PID tùy stage",
    imageFormat: "aml_upgrade_package.img",
    support: "Flash Legacy v2 thử nghiệm",
  },
  {
    chip: "S905X3",
    family: "SM1",
    protocol: "USB Burning Tool v2 · legacy",
    usbIdentity: "VID 0x1B8E · PID tùy stage",
    imageFormat: "aml_upgrade_package.img",
    support: "Flash Legacy v2 thử nghiệm",
  },
];
